import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { ContactBlockComponent } from './contact-block.component';

@NgModule({
  declarations: [ContactBlockComponent],
  imports: [CommonModule, SharedComponentsModule],
  exports: [ContactBlockComponent]
})
export class ContactBlockModule {}
